import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IAddHoliday } from '../../../models/forms/IAddEditHoliday';
import { formatMessage } from '../../../translations/format-message';
import AddEditHolidayCalendarForm from '../forms/add-holiday-calendar-form';
import './add-holiday-calendar.css';

interface IProps {
  id: number;
  selctedYear: number;
  selectedDate: Date;
}

const AddEditHolidaySchedule = (props: IProps) => {
  const { processStore, factoryScheduleStore } = useStore();
  const { resetAddUpdateProcessState, resetProcessDetail } = processStore;

  const {
    factoryScheduleDetails,
    AddFactoryScheduleService,
    addUpdateFactoryScheduleState,
    GetFactoryScheduleByIdService,
  } = factoryScheduleStore;

  const initialValues: IAddHoliday = factoryScheduleDetails;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    if (props.id > 0) {
      GetFactoryScheduleByIdService(
        Number(getTenantIdFromLocalStorage()),
        props.id
      );
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateFactoryScheduleState.success) {
      if (props.id === -1) toast.success(formatMessage('added_success'));
      else toast.success(formatMessage('updated_success'));
      // onModalClosed();
    }
  }, [addUpdateFactoryScheduleState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateFactoryScheduleState.error) {
      toast.error(formatMessage(addUpdateFactoryScheduleState.error));
      resetAddUpdateProcessState();
    }
  }, [addUpdateFactoryScheduleState.error]);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = (values: IAddHoliday) => {
    var addObj: IAddHoliday = {
      TenantId: values.TenantId,
      HolidayName: values.HolidayName.trim(),
      Comment: values.Comment.trim(),
      HolidayDate: values.HolidayDate,
      Year: values.Year,
    };

    if (props.id < 0) {
      AddFactoryScheduleService(addObj);
    }
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetProcessDetail();
  };

  return (
    <React.Fragment>
      <AddEditHolidayCalendarForm
        initialValues={initialValues}
        id={0}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        isLoading={false}
        selectedYear={props.selctedYear}
        selectedDate={props.selectedDate}
      />
    </React.Fragment>
  );
};

export default AddEditHolidaySchedule;
